export default __webpack_public_path__ + "static/media/token_chart.e9972515.png";